import { z } from 'zod';

import { ForeclosureId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const ReopenForeclosureEvent = BaseLoanEvent.extend({
  type: z.literal('reopenForeclosure'),
  foreclosureId: ForeclosureId,
  comment: z.string().optional(),
});
export type ReopenForeclosureEvent = z.infer<typeof ReopenForeclosureEvent>;
